import { StyleSheet, View, type ViewProps } from 'react-native';

export type YStackProps = ViewProps;

export function YStack({ style, accessibilityRole = 'none', ...props }: YStackProps) {
  return <View {...props} accessibilityRole={accessibilityRole} style={[styles.ystack, style]} />;
}

const styles = StyleSheet.create({
  ystack: {
    flexDirection: 'column',
  },
});
